export const BTN_CANCEL = "ABBRECHEN";
export const BTN_ACCEPT = "SPEICHERN";
export const BTN_DELETE = "LÖSCHEN";